import type { TOnboardingStatuses } from '@/store/useAppStore';
import type { TLegalDocumentAcceptanceStatus } from '@/types/Legal.types';
import { isUndefined } from '.';

export const isEverythingSetup = (status: TOnboardingStatuses, isAdmin?: boolean, isContentCreatorOnly = false) => {
  // External creators use the creator application instead of regular user onboarding.
  if (isContentCreatorOnly) return true;

  const { isOrganizationOnboardingCompleted, isUserOnboardingCompleted, isWholenessScreenerCompleted } = status;

  if (!isUndefined(isAdmin) && isAdmin) {
    return isOrganizationOnboardingCompleted && isUserOnboardingCompleted && isWholenessScreenerCompleted;
  }

  return isUserOnboardingCompleted && isWholenessScreenerCompleted;
};

export const isUserMarkedAsPeerSupport = (peerSupportMark: boolean) =>
  (peerSupportMark as unknown as string) === 'yes' ||
  (peerSupportMark as unknown as string) === 'true' ||
  peerSupportMark === true;

export const isLegalDocumentAccepted = (status: TLegalDocumentAcceptanceStatus) => !isUndefined(status.acceptedAt);

export const areRequiredLegalDocumentsAccepted = (statuses: TLegalDocumentAcceptanceStatus[] | null) =>
  Boolean(statuses?.every(isLegalDocumentAccepted));

export const getUnacceptedLegalDocuments = (statuses: TLegalDocumentAcceptanceStatus[] | null) =>
  statuses?.filter((status) => !isLegalDocumentAccepted(status)) ?? [];

export const getUnacceptedContentPolicy = (statuses: TLegalDocumentAcceptanceStatus[] | null) =>
  getUnacceptedLegalDocuments(statuses).find((status) => status.type === 'CONTENT_POLICY') ?? null;

export const hasUnacceptedNonContentPolicyDocument = (statuses: TLegalDocumentAcceptanceStatus[] | null) =>
  getUnacceptedLegalDocuments(statuses).some((status) => status.type !== 'CONTENT_POLICY');
